import { INTAKE_STAGE, intakeStatusLabel } from "@/models/intakeStatus";
const STEP_PAGES = {
    order_qualification: { route: "qualify-order", status: INTAKE_STAGE.QUALIFY_PATIENT },
    clinical_review: { route: "document-review-order", status: INTAKE_STAGE.CLINICAL_REVIEW },
};
/** The step an intake order's status says is open; the backend derives that status from the step records. */
export function openStepOf(status) {
    if (status === INTAKE_STAGE.CLINICAL_REVIEW)
        return "clinical_review";
    if (status === INTAKE_STAGE.QUALIFY_PATIENT)
        return "order_qualification";
    return null;
}
/** The page that works one step of an order: from a feed row today, from a Worklist chip next. */
export function stepRoute(step, orderId, readOnly = false) {
    return { name: STEP_PAGES[step].route, params: { id: orderId }, ...(readOnly ? { query: { ro: "1" } } : {}) };
}
export function stepLabel(step) {
    return intakeStatusLabel(STEP_PAGES[step].status);
}
